module.exports = __webpack_public_path__ + "media/images/undraw_pending_approval_xuu9 (1) 1-cf6878c8d9f8e384eb0fee54d3ffc5a7.png";